var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSehqcLogoHorizontalColorWhite(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_2",
    "data-name": "Layer 2",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 1727.14 392",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: #687e8c;\n      }\n\n      .cls-1, .cls-2, .cls-3, .cls-4, .cls-5, .cls-6, .cls-7, .cls-8, .cls-9, .cls-10, .cls-11, .cls-12, .cls-13, .cls-14 {\n        stroke-width: 0px;\n      }\n\n      .cls-2 {\n        fill: url(#linear-gradient);\n      }\n\n      .cls-3 {\n        fill: url(#linear-gradient-11);\n      }\n\n      .cls-4 {\n        fill: url(#linear-gradient-10);\n      }\n\n      .cls-5 {\n        fill: #4b99ca;\n      }\n\n      .cls-6 {\n        fill: url(#linear-gradient-4);\n      }\n\n      .cls-7 {\n        fill: url(#linear-gradient-2);\n      }\n\n      .cls-8 {\n        fill: url(#linear-gradient-3);\n      }\n\n      .cls-9 {\n        fill: url(#linear-gradient-8);\n      }\n\n      .cls-10 {\n        fill: url(#linear-gradient-9);\n      }\n\n      .cls-11 {\n        fill: url(#linear-gradient-7);\n      }\n\n      .cls-12 {\n        fill: url(#linear-gradient-5);\n      }\n\n      .cls-13 {\n        fill: url(#linear-gradient-6);\n      }\n\n      .cls-14 {\n        fill: #fff;\n      }\n    "), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: -54.13,
    y1: 571.2,
    x2: 351.95,
    y2: 571.2,
    gradientTransform: "translate(20.04 -228.86) rotate(-3.67)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.02,
    stopColor: "#091c67"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.37,
    stopColor: "#6b276d"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.64,
    stopColor: "#962372"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.97,
    stopColor: "#e25681"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-2",
    x1: -54.13,
    y1: 431.49,
    x2: 351.95,
    y2: 431.49,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-3",
    x1: 216.7,
    y1: -632.27,
    x2: 315.63,
    y2: -1004.99,
    gradientTransform: "translate(-243.33 916.99) rotate(15.19) skewX(.11)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#003762"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.26,
    stopColor: "#0e537b"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0d6c9a"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-4",
    x1: 51.25,
    y1: -676.18,
    x2: 150.18,
    y2: -1048.9,
    xlinkHref: "#linear-gradient-3"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-5",
    x1: 223.94,
    y1: -630.35,
    x2: 322.87,
    y2: -1003.06,
    xlinkHref: "#linear-gradient-3"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-6",
    x1: 286.27,
    y1: -613.81,
    x2: 385.2,
    y2: -986.52,
    xlinkHref: "#linear-gradient-3"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-7",
    x1: 113.54,
    y1: 555.82,
    x2: 18.94,
    y2: 252.66,
    gradientTransform: "translate(20.04 -228.86) rotate(-3.67)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.3,
    stopColor: "#0d6c9a"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.52,
    stopColor: "#0f6d9c"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.99,
    stopColor: "#4b99ca"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-8",
    x1: 228.86,
    y1: 519.84,
    x2: 134.25,
    y2: 216.68,
    xlinkHref: "#linear-gradient-7"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-9",
    x1: 251.99,
    y1: 512.62,
    x2: 157.38,
    y2: 209.46,
    xlinkHref: "#linear-gradient-7"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-10",
    x1: 38.07,
    y1: 579.38,
    x2: -56.54,
    y2: 276.22,
    xlinkHref: "#linear-gradient-7"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-11",
    x1: 192.21,
    y1: 531.27,
    x2: 97.6,
    y2: 228.11,
    xlinkHref: "#linear-gradient-7"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "let_s_start_over_copy",
    "data-name": "let&apos;s start over copy"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M206.38,353.05c-83.36,15.99-146.71-19.76-184.84-69.76h-1.03c29.08,58.32,86.57,100.86,156.2,107.74,83.33,8.24,159.62-36.98,194.82-107.74h-41.25c-31.4,33.99-74.69,60.32-123.9,69.76Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M352.58,254.89h30.39c3.97-12.65,6.71-25.89,8.07-39.6,3.86-39-4-76.45-20.7-108.88,5.07,11.35,8.71,22.76,10.69,33.95,6.64,37.53-4.63,78.46-28.44,114.53Z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M84.96,254.66h56.01c8.5,0,9.9-1.59,9.9-11.22,0-.38,0-4.15,0-4.51-.12-8.3-1.75-9.73-9.89-9.73h-55.56c-29.62,0-41.37-5.42-41.37-28.51,0-11.2,0-18.83,0-19.53,0-22.92,11.28-32.14,41.24-32.14h84.94c8.3,0,13.08,6.29,13.08,14.33s-4.53,14.08-12.57,14.08h-86.53c-6.12,0-8.46.71-8.46,8.76,0,1.4.02,5.06,0,5.47-.37,7.17,2.09,9.14,8.46,9.14h60.06c29.49,0,39.21,4.49,39.21,28.4v20.44c9.22-4.95,17.69-11.12,25.17-18.29v-43.38c0-23.01,12.3-37.5,35.02-39.07-.33-62.1-50.9-112.62-113.73-113.18-37.62-.34-71.17,17.31-92.34,44.85-2.66,3.64-5.19,7.38-7.6,11.21-9.89,16.64-15.65,36-15.83,56.7-.43,47.77,28.9,88.93,70.83,106.17Z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M245.75,283.2c-24.79,18.21-55.06,29.15-87.88,29.7-34.6.58-66.75-10.46-92.9-29.61H21.54c38.12,50,101.47,85.76,184.84,69.76,49.21-9.44,92.51-35.77,123.9-69.76h-80.93c-1.23,0-2.43-.04-3.6-.09Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M1.15,175c-.06.57-.12,1.14-.18,1.71-2.68,27.12.3,53.5,7.99,77.95h26.11C17.19,232.39,5.09,205.05,1.15,175Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M310.53,148.77h4.28c24.46,0,32.9,15.39,32.9,32.39v19.53c0,23.74-12.07,28.29-23.64,28.29h-31.82c-4.83,9.22-10.52,17.89-16.97,25.91h77.3c23.81-36.07,35.08-77.01,28.44-114.53-1.98-11.19-5.62-22.6-10.69-33.95C340.91,49.28,284.01,7.76,215.29.96,208.64.31,202.04,0,195.5,0c64.58,17.78,112.81,77.15,115.03,148.77Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "M319.75,190.24v-.74c0-9.62-1.98-13.58-9.88-13.58h-.73c-1.31,9.69-3.48,19.1-6.42,28.16h7.14c6.45,0,9.88-1.87,9.88-13.84Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M157.87,312.9c32.82-.55,63.1-11.49,87.88-29.7-24.75-1.17-37.12-14.62-37.12-38.62v-13.22c-7.49,7.17-15.95,13.34-25.17,18.29v5.01c0,26.71-13.31,28.63-39.21,28.63h-79.28c26.15,19.15,58.3,30.19,92.9,29.61Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M240.7,237.38c0,11.92,5.83,17.51,18.62,17.51h15.96c6.45-8.02,12.14-16.7,16.97-25.91h-51.55v8.4Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M257.4,175.92c-11.96,0-16.7,5.84-16.7,16.45v11.71h62.02c2.94-9.06,5.1-18.47,6.42-28.16h-51.74Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M84.96,254.66c-41.93-17.24-71.26-58.4-70.83-106.17.19-20.7,5.94-40.06,15.83-56.7C14.61,116.22,4.44,144.42,1.15,175c3.94,30.05,16.05,57.39,33.92,79.66h49.9Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M129.91,35.73c62.83.56,113.41,51.09,113.73,113.18,1.36-.09,2.76-.15,4.2-.15h62.69C308.31,77.15,260.08,17.78,195.5,0c-63.97.09-122.01,31.37-157.93,80.58,21.18-27.54,54.73-45.19,92.34-44.85Z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-14",
    d: "M144.24,200.8h-60.06c-6.37,0-8.83-1.97-8.46-9.14.02-.41,0-4.07,0-5.47,0-8.05,2.34-8.76,8.46-8.76h86.53c8.05,0,12.57-6.29,12.57-14.08s-4.78-14.33-13.08-14.33h-84.94c-29.96,0-41.24,9.22-41.24,32.14,0,.7,0,8.33,0,19.53,0,23.1,11.75,28.51,41.37,28.51h55.56c8.15,0,9.77,1.43,9.89,9.73,0,.36,0,4.13,0,4.51,0,9.62-1.4,11.22-9.9,11.22H8.95c2.66,8.46,5.87,16.69,9.61,24.64.63,1.34,1.28,2.67,1.94,3.99h123.74c25.9,0,39.21-1.92,39.21-28.63v-25.45c0-23.91-9.73-28.4-39.21-28.4Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-14",
    d: "M259.32,254.89c-12.79,0-18.62-5.59-18.62-17.51v-8.4h83.37c11.57,0,23.64-4.55,23.64-28.29v-19.53c0-17-8.44-32.39-32.9-32.39,0,0-69.8.05-71.16.15-22.71,1.57-35.02,16.06-35.02,39.07v56.6c0,24.01,12.38,37.45,37.12,38.62,1.18.06,125.78.09,125.78.09,4.51-9.07,8.34-18.55,11.44-28.4h-123.65ZM257.4,175.92h52.47c7.9,0,9.88,3.96,9.88,13.58v.74c0,11.97-3.43,13.84-9.88,13.84h-69.17v-11.71c0-10.61,4.75-16.45,16.7-16.45Z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "544.69 208.69 463.08 208.69 463.08 149.85 448.13 149.85 448.13 282.87 463.08 282.87 463.08 221.94 544.69 221.94 544.69 282.87 559.46 282.87 559.46 149.85 544.69 149.85 544.69 208.69"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "612.64 221.76 680.92 221.76 680.92 208.88 612.64 208.88 612.64 162.91 689.22 162.91 689.22 149.85 597.69 149.85 597.69 282.87 692.05 282.87 692.05 269.8 612.64 269.8 612.64 221.76"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M783.34,149.85h-14.41l-60.81,133.02h15.62l15.84-35.27h72.92l15.84,35.27h15.81l-60.68-132.73-.13-.29ZM806.97,235.29h-61.84l30.92-69.21,30.92,69.21Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "879.71 149.85 864.76 149.85 864.76 282.87 953.65 282.87 953.65 269.8 879.71 269.8 879.71 149.85"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "944.73 162.91 991.13 162.91 991.13 282.87 1006.08 282.87 1006.08 162.91 1052.48 162.91 1052.48 149.85 944.73 149.85 944.73 162.91"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "1170.31 208.69 1088.69 208.69 1088.69 149.85 1073.74 149.85 1073.74 282.87 1088.69 282.87 1088.69 221.94 1170.31 221.94 1170.31 282.87 1185.07 282.87 1185.07 149.85 1170.31 149.85 1170.31 208.69"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1257.24,169.26c8.44-4.71,17.94-7.1,28.24-7.1,15.5,0,28.52,5.22,38.69,15.51l.35.35,9.55-9.55-.32-.35c-5.81-6.31-12.98-11.18-21.31-14.46-8.32-3.28-17.52-4.94-27.34-4.94-13.1,0-25.11,2.94-35.7,8.74-10.6,5.8-19,13.96-24.99,24.23-5.99,10.28-9.03,21.94-9.03,34.67s3.04,24.4,9.03,34.67c5.99,10.28,14.37,18.43,24.9,24.23,10.52,5.8,22.5,8.74,35.6,8.74,9.83,0,19.06-1.69,27.44-5.03,8.39-3.34,15.59-8.24,21.4-14.55l.32-.35-9.56-9.56-.35.36c-10.04,10.41-23.05,15.69-38.68,15.69-10.31,0-19.81-2.39-28.24-7.1-8.43-4.71-15.13-11.25-19.9-19.43-4.77-8.18-7.19-17.49-7.19-27.66s2.42-19.48,7.19-27.66c4.77-8.18,11.46-14.72,19.9-19.43Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1418.77,149.85h-14.41l-60.81,133.02h15.62l15.84-35.27h72.92l15.84,35.27h15.81l-60.68-132.73-.13-.29ZM1442.39,235.29h-61.84l30.92-69.21,30.92,69.21Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1596.62,222.02c5.26-7.16,7.92-16.05,7.92-26.42,0-14.17-4.88-25.46-14.51-33.58-9.61-8.09-23.04-12.19-39.93-12.19h-49.91v133.02h14.95v-41.87h34.96c3.54,0,7.01-.18,10.33-.54l30.01,42.2.15.21h16.5l-32.42-45.5c9.43-3.18,16.81-8.34,21.96-15.34ZM1515.14,162.91h34.59c12.89,0,22.88,2.85,29.67,8.47,6.76,5.6,10.19,13.75,10.19,24.23s-3.43,18.29-10.2,23.95c-6.79,5.68-16.77,8.56-29.67,8.56h-34.59v-65.21Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "1647.73 269.8 1647.73 221.76 1716.01 221.76 1716.01 208.88 1647.73 208.88 1647.73 162.91 1724.31 162.91 1724.31 149.85 1632.78 149.85 1632.78 282.87 1727.14 282.87 1727.14 269.8 1647.73 269.8"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSehqcLogoHorizontalColorWhite);
export default __webpack_public_path__ + "static/media/SEHQC-Logo-Horizontal-Color-White.d43b5a9772ccbecb1b707fe9476a6d00.svg";
export { ForwardRef as ReactComponent };